import { createContext, type RefObject } from 'react';

/** What a control the composer is given (its token meter) needs of the composer. */
export interface ComposerBox {
  /** The composer box: a popover anchors to it, as the chips' do. */
  boxRef: RefObject<HTMLElement | null>;
  /** Puts focus in the textarea. */
  focusInput: () => void;
}

/** Provided by Composer around the controls it is given; null outside a composer. */
export const ComposerBoxContext = createContext<ComposerBox | null>(null);
